// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import {dispatchEvent} from 'fg-frontend/src/lib/dom';
import cookie from 'js-cookie';

class CustomSimpleCollapse extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.triggerActionOnLoad = this.triggerActionOnLoad.bind(this);
  }

  didMount() {
    const {
      simpleCollapseRestoreState,
      storeCookie,
    } = this.props;

    this.openedState = this.getState();

    if (storeCookie && simpleCollapseRestoreState) {
      this.restoreStateFromCookie();
    }

    this.bindEvents();

    // pokud je v location.hash id komponenty, provedeme akci pri loadu (deje se pri otevreni odkazu do noveho tabu}
    this.triggerActionOnLoad();
  }

  willUnMount() {
    const {
      collapseOnClickOutside,
    } = this.props;

    if (collapseOnClickOutside) {
      window.removeEventListener('click', this.handleClickOutside);
    }
  }

  triggerActionOnLoad() {
    if (location.hash != '' && this.element.href.indexOf(location.hash) != -1) {
      dispatchEvent(this.element, 'click');
    }
  }

  getState() {
    const {
      openedStateClass,
    } = this.props;
    let state = false;

    if ($(this.element).hasClass(openedStateClass)) {
      state = true;
    }

    return state;
  }

  bindEvents() {
    const {
      collapseOnClickOutside,
    } = this.props;

    if (collapseOnClickOutside) {
      window.addEventListener('click', this.handleClickOutside);
    }

    this.on('click', this.handleClick);
  }

  // osetreni kliknuti
  handleClick(e) {
    const {
      storeCookie,
      onAfterOpen,
      openedStateClass,
      togglingStateClass,
	  parentContainerId,
    } = this.props;
    const target = this.getTargetByType();

    e.preventDefault();
    e.stopPropagation();

	// zavřeme všechny ostatní filtry
	if (parentContainerId) {
		const elements = $('.active',this.element.closest(parentContainerId));
		Array.from(elements).forEach( (el) => {
		  if(this.element.id != el.id ) {
			$(el).trigger('click')
		  }
		});
	}

    this.element.classList.add(togglingStateClass);
    $(target).slideToggle({
      complete: (a, jumpedToEnd) => {
        this.element.classList.remove(togglingStateClass);
      }
    });

    if (this.openedState) {
      this.element.classList.remove(openedStateClass);
      this.openedState = false;
    } else {
      this.element.classList.add(openedStateClass);
      this.openedState = true;
    }

    this.setTargetPosition();

    this.setLinkText();

    if (storeCookie) {
      this.storeStateToCookie();
    }

    if (onAfterOpen && this.openedState) {
      onAfterOpen();
    }

    $('.js_bootstrap-slider-input').trigger('EDEESHOP_BOOTSTRAP_SLIDER_RELAYOUT');
  }

  // osetreni kliknuti mimo komponentu
  handleClickOutside(e) {
    if (this.openedState && !(e.target.closest(this.element.getAttribute('href')))) {
      dispatchEvent(this.element, 'click');
    }
  }

  // ulozeni stavu komponenty do cookie
  storeStateToCookie() {
    const {
      storeCookie,
      storeCookiePath,
    } = this.props;

    if (storeCookiePath) {
      const cookiePath = window.location.pathname;
      cookie.set(storeCookie + '_path', cookiePath, {expires: 1, path: '/'});
    }

    cookie.set(storeCookie, this.openedState, {expires: 1, path: '/'});
  }

  // nacteni stavu komponenty z cookie
  restoreStateFromCookie() {
    const {
      storeCookie,
    } = this.props;

    const storeCookieValue = cookie.get(storeCookie);

    if (storeCookieValue === 'true') {
      this.openedState = true;
	  this.setTargetPosition();
      this.open();
      this.setLinkText();
    } else if (storeCookieValue === 'false') {
      this.openedState = false;
      this.close();
	  this.setTargetPosition();
      this.setLinkText();
    }
  }

  // otevreni komponenty
  open() {
    const {
      openedStateClass,
    } = this.props;

    let targetElm = $(this.getTargetByType()); // .show();
	targetElm.show();

    this.element.classList.add(openedStateClass);
  }

  // zavreni komponenty
  close() {
    const {
      openedStateClass,
    } = this.props;

    $(this.getTargetByType()).hide();
    this.element.classList.remove(openedStateClass);
  }

  // vrati cilovou komponentu v zavislosti na tom, zda targetujeme podle hodnoty href nebo data-href
  getTargetByType() {
    const {
      type,
      href,
    } = this.props;
    let result;

    if (type == 'href') {
      result = this.element.getAttribute('href');
    } else if (type == 'data-href') {
      result = href;
    }

    return result;
  }

  // aktualizace textace komponenty, pokud existuje
  setLinkText() {
    const {
      simpleCollapseDefault,
      simpleCollapseActive,
    } = this.props;
    let linkText;

    if (this.openedState) {
      linkText = simpleCollapseActive;
    } else {
      linkText = simpleCollapseDefault;
    }
    if (linkText) {
      (this.element).innerHTML = linkText;
    }
  }

	// nastavíme pozici cíle
	setTargetPosition() {

		let getTarget = this.getTargetByType();
		let jqElm = $(getTarget);
		let elm = document.querySelector(getTarget);
		// nastavíme do defaultu
		jqElm.css({'left': '0', 'right': '0'});
		// zjistíme pozici
		let rect = elm.getBoundingClientRect();
		//- console.log(rect.right);
		//- console.log(window.innerWidth);
		if (rect.right > window.innerWidth) {
			jqElm.css({'left': 'auto', 'right': '0'});
		}
	}

}

CustomSimpleCollapse.defaultProps = {
  type: 'href',                       // href | data-href
  selector: '',
  offsetY: -10,
  simpleCollapseRestoreState: true,   // pokud je true, provede se nacteni stavu z cookie v JS, pokud false predpoklada se implementovana logika na serveru
  storeCookie: null,                  // pokud je nadefinovan nazev cookie, uklada do ni stav
  storeCookiePath: false,             // ukladani stavu do cookie vcetne path
  collapseOnClickOutsite: false,      // collapse pri kliknuti mimo komponentu
  simpleCollapseDefault: null,        // vychozi textace komponenty
  simpleCollapseActive: null,         // textace komponenty pri otevrenem stavu
  openedStateClass: 'active',           // trida identifikujici otevreny stav
  togglingStateClass: 'active-animating',           // trida identifikujici animaci pri otevirani/zavirani
  parentContainerId: null,           // id identifikující nadřazený container ve kterém jsou ostatní filtry
  onAfterOpen: () => {
    dispatchEvent(window, 'resize');
  },
}

export default CustomSimpleCollapse;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/CustomSimpleCollapse.js